var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroups = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 3.5,
  r: 2,
  stroke: "#1C1C1A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1C1C1A",
  d: "M11.5 10c0-2.21-1.567-4-3.5-4s-3.5 1.79-3.5 4"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 8.5,
  r: 2,
  fill: "#fff",
  stroke: "#1C1C1A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1C1C1A",
  d: "M8 15c0-2.21-1.567-4-3.5-4S1 12.79 1 15"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 8.5,
  r: 2,
  fill: "#fff",
  stroke: "#1C1C1A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1C1C1A",
  d: "M15 15c0-2.21-1.567-4-3.5-4S8 12.79 8 15"
})));
export { SvgGroups as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjMuNSIgcj0iMiIgc3Ryb2tlPSIjMUMxQzFBIi8+CjxwYXRoIGQ9Ik0xMS41IDEwQzExLjUgNy43OTA4NiA5LjkzMyA2IDggNkM2LjA2NyA2IDQuNSA3Ljc5MDg2IDQuNSAxMCIgc3Ryb2tlPSIjMUMxQzFBIi8+CjxjaXJjbGUgY3g9IjQuNSIgY3k9IjguNSIgcj0iMiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzFDMUMxQSIvPgo8cGF0aCBkPSJNOCAxNUM4IDEyLjc5MDkgNi40MzMgMTEgNC41IDExQzIuNTY3IDExIDEgMTIuNzkwOSAxIDE1IiBzdHJva2U9IiMxQzFDMUEiLz4KPGNpcmNsZSBjeD0iMTEuNSIgY3k9IjguNSIgcj0iMiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzFDMUMxQSIvPgo8cGF0aCBkPSJNMTUgMTVDMTUgMTIuNzkwOSAxMy40MzMgMTEgMTEuNSAxMUM5LjU2NyAxMSA4IDEyLjc5MDkgOCAxNSIgc3Ryb2tlPSIjMUMxQzFBIi8+Cjwvc3ZnPgo=";